// Pure predicates for Sentry's `beforeSend`. No imports, so they can be tested
// without a bundler or a browser (tests/e2e/public/sentry-filters.spec.ts).

// Every first-party script is served from here (Vite output, web/dist/).
const FIRST_PARTY_FRAME = /\/dist\/assets\//;

// A bare "Failed to fetch" that none of our bundles took part in (#543).
//
// Google Tag Manager evaluates tag code that the stack attributes to the *page* URL
// (`/events:25:6686`, a column well past the end of our template line), via an
// `Image.onload` → `fetch` chain. When the request is blocked or the connection
// drops, that rejects unhandled and arrives as JAVASCRIPT-6D/6E/6F/6G: one visitor,
// four pages, nothing we can act on.
//
// Narrow on purpose (#230): our own fetches (feedback, beacons, map) run from
// /dist/assets/, so a failure of theirs has a frame there and is still reported.
// An event with no frames at all is kept too — we can't tell whose it is.
export function isThirdPartyFetchFailure(event) {
    const exception = event && event.exception && event.exception.values && event.exception.values[0];
    if (!exception || exception.type !== 'TypeError' || exception.value !== 'Failed to fetch') {
        return false;
    }

    const frames = (exception.stacktrace && exception.stacktrace.frames) || [];
    if (frames.length === 0) {
        return false;
    }

    return !frames.some((frame) => FIRST_PARTY_FRAME.test(frame.filename || ''));
}
